import { memo } from 'react';
import styled from '@emotion/styled';

type LegendItem = {
  key: string;
  color: string;
  /** Optional display text; falls back to key when absent. */
  label?: string;
};

type Props = {
  legend: LegendItem[];
};

export const CompactChartLegend = memo((props: Props) => {
  return (
    <Root>
      <ColorTable>
        {props.legend.map((item) => (
          <LegendItemContainer key={item.key}>
            <LegendColor color={item.color} />
            <LegendText>{item.label ?? item.key}</LegendText>
          </LegendItemContainer>
        ))}
      </ColorTable>
    </Root>
  );
});

const Root = styled.div`
  padding: 0 5px;
`;

const LegendItemContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
});

const LegendColor = styled.div<{ color: string }>(({ color }) => ({
  width: '12px',
  height: '12px',
  backgroundColor: color,
  marginRight: '4px',
}));

const LegendText = styled.div((style) => ({
  fontFamily: style.theme?.fonts?.semiBold ?? 'var(--font-semibold)',
  fontSize: '12px',
}));

const ColorTable = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  columnGap: '12px',
  justifyContent: 'center',
});
